export const FALLBACK_KEYWORD_OPTIONS = ["Top", "Best", "Most Recommended"];

export const resolveDefaultKeywordOptions = (customerUiInfo) =>
    customerUiInfo?.rankAttribute ?? FALLBACK_KEYWORD_OPTIONS;

// Per-user cap comes from users.feature_flags.max_keywords in the sign-in response.
// Absent / invalid -> fall back to the configured option count.
export const resolveMaxKeywords = (user, keywordOptionsLength) => {
    const configured = Number(user?.feature_flags?.max_keywords);
    return Number.isInteger(configured) && configured > 0 ? configured : keywordOptionsLength;
};
